module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group py-0"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "type": _vm.$browser.isIE() ? 'text' : 'date',
      "placeholder": "YYYY-MM-DD",
      "hide-details": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "type": _vm.$browser.isIE() ? 'text' : 'time',
      "placeholder": "HH:MM",
      "hide-details": ""
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a2c315e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateTime.vue
// module id = 1088
// module chunks = 1